import React, {memo} from 'react';
import PropTypes from 'prop-types';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-react';

const Editor = ({value, onChange, onBlur }) => {
  return (
    <CKEditor
      editor={ClassicEditor}
      data={value}
      onChange={(event, editor) => {
        onChange && onChange({target: {value: editor.getData()}});
      }}
      onBlur={onBlur}
    />
  );
};

export default memo(Editor);

Editor.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  onBlur: PropTypes.func, 
};
